import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores'

interface Props {
  children: React.ReactNode
}

function useHydrated() {
  const [hydrated, setHydrated] = useState(false)
  useEffect(() => {
    // useAuthStore.persist.hasHydrated() est synchrone après le premier render
    const check = () => setHydrated(useAuthStore.persist.hasHydrated())
    check()
    const unsub = useAuthStore.persist.onFinishHydration(() => setHydrated(true))
    return unsub
  }, [])
  return hydrated
}

export function ProtectedRoute({ children }: Props) {
  const hydrated = useHydrated()
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)

  if (!hydrated) return null

  if (!isAuthenticated) return <Navigate to='/' replace />

  return <>{children}</>
}

export function PublicOnlyRoute({ children }: Props) {
  const hydrated = useHydrated()
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)

  if (!hydrated) return null

  if (isAuthenticated) return <Navigate to='/app' replace />

  return <>{children}</>
}
